import React from "react";
import useField, { useFieldProps } from "src/hooks/form/useField";
import RfqBidContainerTabs from './RfqBidsComponents/RfqBidContainerTabs';

const useRfqBids = <T>(props: useFieldProps<T>) => {
  const formOptions = {
    rules: [
      {
        validator: (rule, value, callback) => {
          const noError = Object.keys(value?.bids || {}).every(key => value.bids[key].length);
          if (value?.bids && noError) {
            return callback();  
          }
          return callback('Please select a bid.');
        }
      }
    ],
  };

  const field = useField({
    ...props,
    formOptions,
  });
  
  const decorator = (child: React.ReactElement): React.ReactNode => {
    return field.decorator(
      React.createElement(
        RfqBidContainerTabs,
        {...child.props},
      )
    );
  };

  return {
    ...field,
    decorator,
  };

};

export default useRfqBids;
